module.exports = __webpack_public_path__ + "static/akinwale-399a07aacc487a113d5caec56816b9c5.png";